export default __webpack_public_path__ + "static/1808-f978cfd02864dc712972695eafc7b708.gif";